module.exports = __webpack_public_path__ + "img/love.a133ce09.png";